import * as React from "react";
import { Box } from "@mui/material";
import { EditableTable } from "../../../../../../components/Tables/NewEditableTable";
import { useMIS } from "../MISContext";
import { secondAxios } from "../../../../../../api/axios";

const fontSize = "14px";
const cellPadding = "12px";

export default function PayablesTab() {
  const { poPayablesData, poPayablesLoading } = useMIS();
  const [rows, setRows] = React.useState([]);

  React.useEffect(() => {
    setRows(poPayablesData || []);
  }, [poPayablesData]);

  const columns = React.useMemo(
    () => [
      {
        accessorKey: "poNumber",
        header: "PO #",
        enableEditing: false,
        muiTableHeadCellProps: {
          sx: { fontSize, padding: cellPadding },
        },
        muiTableBodyCellProps: {
          sx: { fontSize, padding: cellPadding },
        },
      },
      {
        accessorKey: "forWhom",
        header: "Vendor",
        enableEditing: false,
        muiTableHeadCellProps: {
          sx: { fontSize, padding: cellPadding },
        },
        muiTableBodyCellProps: {
          sx: { fontSize, padding: cellPadding },
        },
      },
      {
        accessorKey: "paymentDate",
        header: "Date",
        enableEditing: true, // only this and approver are editable
        muiEditTextFieldProps: { type: "date" },
        muiTableHeadCellProps: {
          sx: { fontSize, padding: cellPadding },
        },
        muiTableBodyCellProps: {
          sx: { fontSize, padding: cellPadding },
        },
      },

      {
        accessorKey: "amount",
        header: "Amount $",
        enableEditing: false,
        muiTableHeadCellProps: {
          sx: { fontSize, padding: cellPadding },
        },
        muiTableBodyCellProps: {
          sx: { fontSize, padding: cellPadding },
        },
      },
      {
        accessorKey: "remarks",
        header: "Remarks",
        enableEditing: false,
        muiTableHeadCellProps: {
          sx: { fontSize, padding: cellPadding },
        },
        muiTableBodyCellProps: {
          sx: { fontSize, padding: cellPadding },
        },
      },
      {
        accessorKey: "approver",
        header: "Approver",
        enableEditing: true,
        muiTableHeadCellProps: {
          sx: { fontSize, padding: cellPadding },
        },
        muiTableBodyCellProps: {
          sx: { fontSize, padding: cellPadding },
        },
      },
      {
        accessorKey: "sdaf",
        header: "Payment Date",
        enableEditing: false,
        muiEditTextFieldProps: { type: "date" },
        muiTableHeadCellProps: {
          sx: { fontSize, padding: cellPadding },
        },
        muiTableBodyCellProps: {
          sx: { fontSize, padding: cellPadding },
        },
      },
    ],
    [],
  );

  const useGetPayments = () => {
    console.log("useGetPayments called, data length:", rows?.length || 0);
    return {
      data: rows,
      isError: false,
      isFetching: poPayablesLoading,
      isLoading: poPayablesLoading,
    };
  };

  const useCreatePayment = () => ({
    mutateAsync: async () => {},
    isPending: false,
  });

  const useUpdatePayment = () => ({
    mutateAsync: async ({ values }) => {
      const { id, approver, paymentDate } = values || {};
      if (!id) return;
      try {
        await secondAxios.patch(`/payment/${id}`, {
          approver,
          paymentDate,
        });
        setRows((prev) =>
          prev.map((row) =>
            row.id === id
              ? {
                  ...row,
                  approver,
                  paymentDate,
                }
              : row
          )
        );
      } catch (error) {
        console.error("Failed to update payment approver:", error);
        throw error;
      }
    },
    isPending: false,
  });

  const useDeletePayment = () => ({
    mutateAsync: async () => {},
    isPending: false,
  });

  const hooks = React.useMemo(
    () => ({
      useCreateItem: () => useCreatePayment(),
      useGetItems: useGetPayments,
      useUpdateItem: () => useUpdatePayment(),
      useDeleteItem: () => useDeletePayment(),
    }),
    [poPayablesData, poPayablesLoading]
  );

  return (
    <Box width="100%">
      <EditableTable
        name="Payables (from PO Data)"
        columns={columns}
        hooks={hooks}
        // use row editing so user edits via the action column, not by clicking cells
        editMode="row"
        enableCreate={false}
        enableEditing={true}
        enableDelete={false}
        initialData={{
          paymentDate: "",
          amount: "",
          forWhom: "",
          approver: "",
          poId: "",
          invoiceAmount: "",
          remarks: "",
        }}
      />
    </Box>
  );
}
